export class Sacado {
	cPFCNPJ: string;
	nome: string;
	email: string;
	cEP: string;
	endereco: string;
	numero: string;
	bairro: string;
	complemento: string;
	cidade: string;
	uF: string;
	codigoLogradouro: number;
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/models/sacado.model.ts